import $ from 'jquery';

export const loadPrice = function (element, callback = null, urlPrice = null, attrDataName = 'data-product-price-id') {
    let priceUrl = urlPrice ? urlPrice : element.getAttribute('data-ajax-price-url');
    let id = element.getAttribute(attrDataName);
    const unit = element.getAttribute('data-unit');

    let elementAppendLoader = $(element).find('.price_append_loader');
    const requestData = {id: id};
    if (unit) {
        requestData.unit = unit;
    }

    return $.ajax(priceUrl, {
        method: 'GET',
        data: requestData,
        beforeSend: function () {
            elementAppendLoader.removeClass('d-none');
            elementAppendLoader.addClass('d-block');
        },
    }).done(function (response) {
        elementAppendLoader.removeClass('d-block');
        elementAppendLoader.addClass('d-none');

        $(element).attr('data-price', response['price']);
        $(element).html(response['price'] + elementAppendLoader[0].outerHTML);

        let priceUnknown = element.getAttribute('data-price-unknown');
        if (response['price'] !== priceUnknown && 'cart' in response) {
            let printHide = $(element).parent().parent().find('td.print-hide');
            printHide.replaceWith(response['cart']);
        }

        if (callback) {
            callback(response);
        }
    });
};

export default loadPrice;
